<template>
  <div class="mt-2">
    <h3 class="font-medium mb-2"><Skeletor /></h3>
    <p v-for="i in 3" :key="i" class="mb-1" :class="i === 3 ? 'w-1/2' : ''">
      <Skeletor />
    </p>
  </div>
</template>

<script setup lang="ts">
import { Skeletor } from "vue-skeletor";
</script>
